const { createConstant } = require('../../helpers')

const service = 'market'

module.exports = {
  GET_CARTS: createConstant(service, 'GET_CARTS'),
  GET_CARTS_SUCCESS: createConstant(service, 'GET_CARTS_SUCCESS'),
  GET_CARTS_ERROR: createConstant(service, 'GET_CARTS_ERROR'),
  GET_CARTS_RESET: createConstant(service, 'GET_CARTS_RESET'),

  GET_SERVICES_CARTS: createConstant(service, 'GET_SERVICES_CARTS'),
  GET_SERVICES_CARTS_SUCCESS: createConstant(service, 'GET_SERVICES_CARTS_SUCCESS'),
  GET_SERVICES_CARTS_ERROR: createConstant(service, 'GET_SERVICES_CARTS_ERROR'),
  GET_SERVICES_CARTS_RESET: createConstant(service, 'GET_SERVICES_CARTS_RESET'),

  GET_CARTS_COUNT: createConstant(service, 'GET_CARTS_COUNT'),
  GET_CARTS_COUNT_SUCCESS: createConstant(service, 'GET_CARTS_COUNT_SUCCESS'),
  GET_CARTS_COUNT_ERROR: createConstant(service, 'GET_CARTS_COUNT_ERROR'),
  GET_CARTS_COUNT_RESET: createConstant(service, 'GET_CARTS_COUNT_RESET'),

  CREATE_CART: createConstant(service, 'CREATE_CART'),
  CREATE_CART_SUCCESS: createConstant(service, 'CREATE_CART_SUCCESS'),
  CREATE_CART_ERROR: createConstant(service, 'CREATE_CART_ERROR'),
  CREATE_CART_RESET: createConstant(service, 'CREATE_CART_RESET'),

  CREATE_SERVICES_CART: createConstant(service, 'CREATE_SERVICES_CART'),
  CREATE_SERVICES_CART_SUCCESS: createConstant(
    service,
    'CREATE_SERVICES_CART_SUCCESS',
  ),
  CREATE_SERVICES_CART_ERROR: createConstant(
    service,
    'CREATE_SERVICES_CART_ERROR',
  ),
  CREATE_SERVICES_CART_RESET: createConstant(
    service,
    'CREATE_SERVICES_CART_RESET',
  ),

  DELETE_CART: createConstant(service, 'DELETE_CART'),
  DELETE_CART_SUCCESS: createConstant(service, 'DELETE_CART_SUCCESS'),
  DELETE_CART_ERROR: createConstant(service, 'DELETE_CART_ERROR'),
  DELETE_CART_RESET: createConstant(service, 'DELETE_CART_RESET'),

  REORDER: createConstant(service, 'REORDER'),
  REORDER_SUCCESS: createConstant(service, 'REORDER_SUCCESS'),
  REORDER_ERROR: createConstant(service, 'REORDER_ERROR'),
  REORDER_RESET: createConstant(service, 'REORDER_RESET'),
}
